var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from 'react';
import { useApiClient } from '../use-api-client';
import { RolesContext } from './roles-context';
export const RolesProvider = function SessionProvider(props) {
    const [roles, setRoles] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const apiClient = useApiClient();
    const loadRoles = () => __awaiter(this, void 0, void 0, function* () {
        const currentUserId = sessionStorage.getItem('currentUserId');
        const rolesPromise = currentUserId
            ? apiClient.profileControllerGetUserRoles({
                profileId: currentUserId,
            })
            : apiClient.profileControllerGetCurrentUserRoles();
        try {
            const res = yield rolesPromise;
            setRoles(res.roles);
        }
        catch (e) {
            // biome-ignore lint/suspicious/noConsole: debugging
            console.error('Unable to load user roles', e);
        }
        finally {
            setIsLoading(false);
        }
    });
    useEffect(() => {
        if (apiClient === null || apiClient === void 0 ? void 0 : apiClient.isAuthenticated) {
            void loadRoles();
        }
    }, [apiClient === null || apiClient === void 0 ? void 0 : apiClient.isAuthenticated]);
    useEffect(() => {
        if (apiClient === null || apiClient === void 0 ? void 0 : apiClient.authenticationFailed) {
            setIsLoading(false);
        }
    }, [apiClient === null || apiClient === void 0 ? void 0 : apiClient.authenticationFailed]);
    const contextValue = useMemo(() => {
        return {
            roles,
            isLoading,
            reload: loadRoles,
        };
    }, [roles, isLoading]);
    return (_jsx(RolesContext.Provider, { value: contextValue, children: props.children }));
};
